import { render, staticRenderFns } from "./top-sidebar.vue?vue&type=template&id=4c8c8640&"
import script from "./top-sidebar.vue?vue&type=script&lang=js&"
export * from "./top-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports